import React from "react";
import { Place, Location } from "../types";

interface PlacesMapWithRoutingProps {
  places: Place[];
  setPlaceDetail: (place: Place | null) => void;
  placeDetail: Place | null;
  location: Location | null;
  setLocation: (location: Location | null) => void;
  user_id: string;
}

export default function PlacesMapWithRouting({
  places,
  setPlaceDetail,
  placeDetail,
  location,
  setLocation,
  user_id,
}: PlacesMapWithRoutingProps) {
  return (
    <div style={{ padding: 16 }}>
      <h2>Places Map With Routing</h2>
      <p>Funkcionalita places map with routing будет implementována позже</p>
    </div>
  );
}
